import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { fetchMaintenanceState, MaintenancePage } from '@/features/maintenance'
import { buildPageTitle } from '@/shared/lib/page-title'

// `from` guarda a rota que o aluno tentou abrir, para devolvê-lo exatamente
// nela quando a janela terminar.
const maintenanceSearchSchema = z.object({
  from: z.string().optional()
})

export const Route = createFileRoute('/manutencao')({
  beforeLoad: async () => {
    const maintenance = await fetchMaintenanceState()

    // Fora da janela ninguém fica preso aqui — vale tanto para acesso direto à
    // URL quanto para o recarregamento logo depois da manutenção terminar.
    if (!maintenance?.active) throw redirect({ to: '/' })
  },
  validateSearch: maintenanceSearchSchema,
  head: () => ({
    meta: [{ title: buildPageTitle('Manutenção') }]
  }),
  component: MaintenancePage
})
